import React, { useRef, useState, useEffect, Suspense } from 'react'
import { Paper, Box, CircularProgress } from '@mui/material'

const Placeholder = ({ minHeight }) => (
  <Paper variant='outlined' sx={{ p: 3 }}>
    <Box display='flex' justifyContent='center' alignItems='center' height={minHeight - 48}>
      <CircularProgress />
    </Box>
  </Paper>
)

// Renders a lightweight placeholder until the section scrolls near the viewport,
// then mounts (and code-splits) the chart inside. Avoids rendering every chart at once.
export const LazyChartSection = ({ children, minHeight = 468 }) => {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node || visible) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin: '200px' }
    )

    observer.observe(node)

    return () => observer.disconnect()
  }, [visible])

  return (
    <div ref={ref} style={{ minHeight }}>
      {visible ? (
        <Suspense fallback={<Placeholder minHeight={minHeight} />}>{children}</Suspense>
      ) : (
        <Placeholder minHeight={minHeight} />
      )}
    </div>
  )
}
